// third-party
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { HashHistory } from 'history';

// project imports
import { reducer as oidcReducer } from 'redux-oidc';
import accountReducer from './accountReducer';
import snackbarReducer from './slices/snackbar';
import menuReducer from './slices/menu';
import simulationReducer from './slices/simulation';
import notificationReducer from './slices/notification';
import paramsReducer from './slices/params';
import attentionClassesReducer from './slices/attentionClasses';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = (history: HashHistory) =>
    combineReducers({
        oidc: oidcReducer,
        account: accountReducer,
        router: connectRouter(history),
        snackbar: snackbarReducer,
        menu: menuReducer,
        simulation: simulationReducer,
        params: paramsReducer,
        attentionClasses: attentionClassesReducer,
        notification: notificationReducer
    });

export default reducer;
